<template>
    <div class="flex gap-2">
        <!--Remarks: shown if debit account is supplier, credit account account associated with bank account (settings) and entry line date is in the future (i think :S, as of 2026-01-30) -->
        <div v-if="showPayNow" class="flex gap-2 relative">
            <input
                id="pay-now"
                v-model="payNow"
                :disabled="!isValidPayment"
                type="checkbox"
                class="checkbox self-center"
            >
            <label for="pay-now" class="self-center pr-4">Legg til betaling</label>
            <tooltip
                v-if="errors.length"
                placement="top"
                error-tooltip
            >
                <template #tooltipAnchor>
                    <i class="i-ph-asterisk block text-error text-xs mt-1"/>
                </template>

                <template #tooltipContent>
                    <div class="flex flex-col gap-1 py-1">
                        <i class="i-ph-warning-fill block text-error text-lg"/>
                        <div>{{ $t(errors[0]) }}</div>
                    </div>
                </template>
            </tooltip>
        </div>
        <UButton
            ref="submitButton"
            :disabled="isSubmitDisabled"
            :color="isSubmitDisabled ? 'neutral' : 'primary'"
            :variant="isSubmitDisabled ? 'outline' : 'solid'"
            :data-cy="TransactionManagerCy.ButtonSubmit"
            @click="submit"
        >
            {{ isEditing ? 'Endre' : 'Bokfør' }}
        </UButton>
    </div>
</template>
<script setup lang="ts">

import {computed, onMounted, onUnmounted, useTemplateRef} from 'vue'
import {bankAccounts} from '@/bank/bank-account.service'
import Tooltip from '@/components/Tooltip.vue'
import {useSetting} from '@/setting/setting.service'
import {useTransactionCreator} from '@/transaction/create-transaction/TransactionCreator.service'
import {TransactionManagerCy} from '@/transaction/TransactionManagerCy'
import {usePayNow} from '@/transaction/create-transaction/usePayNow'
import hotkeys from 'hotkeys-js'

const keybindSubmit = 'ctrl+shift+enter'

const submitDetails = useTemplateRef<{ open: boolean }>('submit-details')
const {setting: defaultOutgoingPaymentAccount} = useSetting<string>('DEFAULT_OUTGOING_PAYMENT_ACCOUNT')
const {transactionEntryLines, entryLinesAreValid} = useTransactionCreator()

const emit = defineEmits(['submit'])

const props = defineProps({
    isEditing: {
        type: Boolean,
        required: true
    },
    isLoading: {
        type: Boolean,
        required: true
    },
    isEditSubmitDisabled: {
        type: Boolean,
        default: false
    }
})

const defaultOutgoingPaymentAccountValue = computed(() => {
    return defaultOutgoingPaymentAccount.value.value
})

const {showPayNow, isValidPayment, payNow, errors} = usePayNow(transactionEntryLines, bankAccounts, defaultOutgoingPaymentAccountValue, props.isEditing)

const submit = () => {
    if (isSubmitDisabled.value) {
        return
    }
    emit('submit', {payNow: payNow.value})
    if (submitDetails.value) {
        submitDetails.value.open = false
    }
}

const isSubmitDisabled = computed(() => {
    if (!props.isEditing) {
        return !entryLinesAreValid.value || props.isLoading
    }
    return props.isLoading || props.isEditSubmitDisabled
})

onMounted(() => {
    hotkeys(keybindSubmit, () => {
        submit()
    })
})

onUnmounted(() => {
    hotkeys.unbind(keybindSubmit)
})

</script>

<style scoped>

</style>